<template>
  <div class="c-edit-visit" @click="close">
    <n-loader :loading="$var('load')" />
    <div class="form" @click.stop>
      <div class="title main">Редактирование посещения</div>
      <div class="time-selector-wrapper nomr">
        <div class="title">
          Точка контроля:
        </div>
        <n-select class="new-select" readonly :data="locationPoints" :value.sync="locationPoint" />
      </div>
      <div class="time-selector-wrapper nomr">
        <div class="title">
          Филиал:
        </div>
        <n-select class="new-select" readonly :data="branches" :value.sync="branch" />
      </div>
      <div class="time-selector-wrapper nomr">
        <div class="title">
          Тип посещения:
        </div>
        <n-select name="inputdisabled" :data="types" v-bind="$form.input('type', 'select')" readonly class="new-select" />
      </div>
      <div class="time-selector-wrapper">
        <div class="title">
          Время посещения:
        </div>
        <div class="time-selector">
          <n-input
            :placeholder="'00'"
            type="text"
            class="new-time-input"
            :maxlength="2"
            v-bind="$form.input('hours')"
            @input="onTimeInput('hours', 23)"
            @blur="onBlurPad('hours')"
          />
          :
          <n-input
            :placeholder="'00'"
            type="text"
            class="new-time-input"
            :maxlength="2"
            v-bind="$form.input('minute')"
            @input="onTimeInput('minute', 59)"
            @blur="onBlurPad('minute')"
          />
        </div>
      </div>
      <div v-if="user.ableChooseVisitDay" class="field check-box" @click="sendInDate = !sendInDate">
        <div class="box">
          <img v-show="!sendInDate" :src="imgDone" alt="">
        </div>
        <div class="title">
          Автоопределение даты учета посещения
        </div>
      </div>
      <div v-show="sendInDate" class="time-selector-wrapper">
        <div class="title">
          Дата учета:
        </div>
        <c-date-picker :pre-date="[newInDate]" :date.sync="newInDate" />
      </div>
      <n-input v-bind="$form.input('editComment')" title="Комментарий (Не обязательно)" /><br>
      <div class="buttons">
        <n-button class="cancel" @click="close">Отмена</n-button>
        <n-button @click="add">Сохранить</n-button>
      </div>
    </div>
  </div>
</template>

<script>

import imgDone from '../../assets/done.svg'

export default {
  name: 'CAddVisit',
  props: {
    visit: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      default() {
        return {}
      },
    },
    locationPoints: {
      type: Array,
      required: true,
    },
    branches: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      imgDone,
      types: [
        { value: 'enter', title: 'Приход', },
        { value: 'leave', title: 'Уход', },
      ],
      sendInDate: false,
      type: {},
      hours: [],
      minutes: [],
      locationPoint: {},
      newInDate: new Date(this.visit.inDate),
      branch: {},
    }
  },
  created() {
    this.$form.init({
      hour: {},
      minute: {},
      type: {},
      editComment: '',
    })
    this.generateHours()
    this.findTime()
    this.locationPoint = this.visit.locationPoint
    this.branch = this.visit.branch
  },
  methods: {
    onTimeInput(field, max) {
      let value = this.$form.get(field)

      value = value.replace(/\D/g, '')

      if (value.length > 2) {
        value = value.slice(0, 2)
      }

      const num = parseInt(value || '0')

      if (num > max) {
        value = max.toString().padStart(2, '0')
      }

      this.$form.set(field, value)
    },
    onBlurPad(field) {
      const val = this.$form.get(field)
      if (val !== undefined && val !== null && val.length === 1) {
        const padded = val.padStart(2, '0')
        this.$form.set(field, padded)
      }
    },
    findTime() {
      const hour = $app.date.format(this.visit.createdAt, 'hours')
      const minute = $app.date.format(this.visit.createdAt, 'minutes')
      this.$form.set('hours', hour)
      this.$form.set('minute', minute)
      this.$form.set('type', $n.find(this.types, (e) => {
        if (e.value === this.visit.type) {
          return e
        }
      }))
    },
    close() {
      this.$emit('update:show', false)
    },
    generateHours() {
      this.hours = Array.from({ length: 24, }, (_, i) => ({
        value: i > 9?i:'0'+(i),
        title: i > 9?i:'0'+(i),
      }))
      this.minutes = Array.from({ length: 60, }, (_, i) => ({
        value: i > 9?i:'0'+(i),
        title: i > 9?i:'0'+(i),
      }))
    },
    add() {
      this.$var('load', true)
      const data = {
        date: new Date(new Date(this.visit.createdAt).setHours(this.$form.get('hours'), this.$form.get('minute'), 0, 0)),
        year: new Date(this.visit.createdAt).getFullYear()+'',
        editComment: this.$form.get('editComment'),
        type: this.$form.get('type.value'),
        locationPointId: this.locationPoint?.id,
        branchId: this.branch?.id,
      }

      if (this.sendInDate) {
        data.newInDate = this.newInDate
      }

      $api.visits.edit(this.visit.id, $app.auth.user().companyId, data).then(() => {
        this.close()
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.c-edit-visit {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: #00000080;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;


  .field {
    flex: 1;
    display: flex;
    margin-bottom: 15px;
    .n-input {
      margin-left: 25px;
      min-width: 100px;
    }
    &.check-box {
      display: flex;
      align-items: center;
      width: 100%;
      .box {
        margin-right: 15px;
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        border: 1px solid #000000;
        padding: 1px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .title {
        justify-content: left;
        font-size: 14px;
        margin-bottom: 0;
      }
    }
  }


  .buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .n-button {
      background-color: var(--primary);
      color: #FFFFFF;
      border: none;
      border-radius: 12px;
      height: 48px;
      padding: 0 24px;
      &.cancel {
        background-color: #ffffff;
        color: var(--primary);
        font-weight: 700;
        border: 1px solid var(--primary);
      }
    }
  }
  .buttons {
    width: 100%;
  }
  .form {
    padding: 15px;
    z-index: 1001;
    min-width: 460px;
    min-height: 200px;
    border-radius: 16px;
    background-color: #FFFFFF;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: stretch;
    .title {
      font-size: 16px;
      color: #000000;
      font-weight: 500;
      &.main {
        margin-bottom: 15px;
      }
    }
    .time-selector-wrapper {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      .title {
        width: 125px;
        margin-right: 15px;
        font-weight: normal;
        font-size: 14px;
        color: #000000;
      }
    }

    .new-time-input {
      width: 50px;
      border-radius: 12px;
      text-align: center;
      box-shadow: 0 0 0 1px #e0e3f0;
      margin: 0 2px;

      ::v-deep {
        .n-input {
          border: none !important;
        }

        .n-content {
          width: 50px;
          height: 40px;
          padding: 6px 10px 6px 15px;
        }
      }
    }

    .time-selector {
      display: flex;
      align-items: center;
      justify-content: start;
      ::v-deep {

        .n-select {
          .v-select {
            padding: 2px;
          }
          .n-icon {
            display: none;
          }
          .n-text {
            text-align: center;
          }
          &:first-child {
            margin-right: 5px;
          }
          &:last-child {
            margin-left: 5px;
          }
        }
      }
    }
  }
}
</style>
